import CircularProgress from '@mui/material/CircularProgress'
import {LoadingBox} from './LoadingIconStyle'
import PropTypes from 'prop-types'

export default function LoadingIcon({title}) {
  return (
    <LoadingBox variant='LoadingBox' data-testid='loading-box'>
      <CircularProgress title={title} data-testid='circular-progress' />
    </LoadingBox>
  )
}

LoadingIcon.propTypes = {
  title: PropTypes.string.isRequired
}
